import React, {Component} from 'react';
import News from './NewsComponent';
import RangList from './RangListComponent';
import {Card, CardTitle, CardSubtitle, CardBody, Popover, PopoverBody} from 'reactstrap';
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption
} from 'reactstrap';

import {Link} from 'react-router-dom';
import axios from 'axios';


import {serverPath, sponsors} from "./common";

//styles
import 'bootstrap/dist/css/bootstrap.css';//bootstrap goes here so we can overwrite classes in custom css(homepage.css)
import '../css/homepage.css';
import '../css/common.css';

class HomePage extends Component{

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            tooltip1: false,
            activeIndex: Math.floor(Math.random()*sponsors.length)
        };

        this.toggle = this.toggle.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    handleClick(path) {
        var self = this;
        axios.get(serverPath + "authService.php", {params: {action: 'whoIsLoggedIn'}})
            .then(function(response){
                self.setState({user: response.data});

                if(self.state.user === null) {
                    self.setState({tooltip1: true});
                }
                else
                {
                    var role = self.state.user.roleName;
                    self.props.history.push("/" + role[0] + path);
                }
            });
    }

    toggle() {
        this.setState({tooltip1: !this.state.tooltip1});
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === sponsors.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? sponsors.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    render(){
        const activeIndex = this.state.activeIndex;

        const slides = sponsors.map((item) => {
            return (
                <CarouselItem
                    onExiting={this.onExiting}
                    onExited={this.onExited}
                    key={item.key}
                >
                    <img src={item.src} alt={item.altText} height={'300px'} width={'100%'}/>
                    <a href={item.href} target={'_blank'}>
                        <CarouselCaption captionText={item.description} captionHeader={item.caption} />
                    </a>
                </CarouselItem>
            );
        });


        return (
            <div id="homepage-container">
                <div className="row mt-5">
                    <div className="col-md-10 offset-md-1">
                        <div className="row">
                            <div className="card-container col-lg-4 col-md-12 col-sm-12"> 
                                <Card>
                                    <CardTitle> <span className="fa fa-graduation-cap"></span> Kursevi </CardTitle>
                                    <hr/>
                                    <CardBody>
                                        Kursevi u okviru kojih su ubačeni
                                        dodatni domaći zadaci, zadaci sa rokova, časova vežbi, itd. su:<br/>

                                        <ul id="hpCourseList">
                                            <li onClick={(event) => this.handleClick("/courses/1")}> Programiranje 1 (modul matematika) </li>
                                            <li onClick={(event) => this.handleClick("/courses/2")}> Programiranje 1 (smer informatika) </li>
                                            <li onClick={(event) => this.handleClick("/courses/3")}> Programiranje 1 (izdvojeni zadaci) </li>
                                            <li onClick={(event) => this.handleClick("/courses/5")}> Programiranje 2 (modul matematika) </li>
                                            <li onClick={(event) => this.handleClick("/courses/4")}> Programiranje 2 (smer informatika) </li>
                                            <hr/>
                                            <li onClick={(event) => this.handleClick("/courses/6")}> Operativni sistemi </li>
                                            <hr/>
                                            <li onClick={(event) => this.handleClick("/courses/7")}> Dizajn programskih jezika </li>
                                            <li onClick={(event) => this.handleClick("/courses/8")}> Programske paradigme (R) </li>
                                            <li onClick={(event) => this.handleClick("/courses/9")}> Programske paradigme (I) </li>
                                            <Popover placement="top" isOpen={this.state.tooltip1} target="hpCourseList" toggle={this.toggle}>
                                                <PopoverBody> Prijavite se na sistem...</PopoverBody>
                                            </Popover>
                                        </ul>
                                    </CardBody>

                                    {/*<CardTitle> <span className="fa fa-code"></span> Algoritamski zadaci </CardTitle>*/}
                                    {/*<hr/>*/}
                                    {/*<CardBody>*/}
                                    {/*Na ovoj stranici možete naći razne algoritamske zadatke koji mogu*/}
                                    {/*da posluže za pripremu algoritamskih ispita, kao i za pripremu za*/}
                                    {/*tehničke intervjue u raznim firmama. <br/>*/}
                                    {/*</CardBody>*/}
                                    {/*<Button tag = {Link} to = {'/algorithms'} className="mt-auto" color="info"> Vidi sve zadatke </Button>*/}
                                </Card>
                             </div>
                             <div className="card-container col-lg-8 col-md-12 col-sm-12">
                                <Card className="">
                                    <CardTitle> <span className="fa fa-building"></span>  </CardTitle>
                                    <hr/>
                                    <CardBody>
                                        <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous} autoPlay={true} animationSpeed={5000}>
                                            <CarouselIndicators items={sponsors} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
                                            {slides}
                                            <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                                            <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
                                        </Carousel>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-10 offset-md-1">
                        <div className="row">
                            <div className="card-container col-md-4 col-sm-12">
                                <Card>
                                    <CardTitle> <span className="fa fa-bar-chart"></span> Svi kursevi </CardTitle>
                                    <CardSubtitle> Korisnici su sortirani po broju tačno urađenih zadataka </CardSubtitle>
                                    <hr/>
                                    <CardBody>
                                        <RangList algorithmRangList={false}/>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="card-container col-md-4 col-sm-12">
                                <Card>
                                    <CardTitle> <span className="fa fa-bar-chart"></span> Algoritmi </CardTitle>
                                    <CardSubtitle> Korisnici su sortirani po broju tačno urađenih algoritamskih zadataka </CardSubtitle>
                                    <hr/>
                                    <CardBody>
                                        <RangList algorithmRangList={true}/>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="card-container col-md-4 col-sm-12">
                                <Card>
                                    <CardTitle>
                                        <div className={'row'}>
                                            <div className={'col'}>
                                                <span className="fa fa-newspaper-o"></span> Novosti i obaveštenja
                                            </div>
                                            <div>
                                                {this.state.user != null
                                                && this.state.user.roleName !== 'student'
                                                && <a href={"/news"}><span tag={Link} to={"/news"} className={"fa fa-edit"}></span></a>}
                                            </div>
                                        </div>
                                    </CardTitle>

                                    <hr/>
                                    <CardBody className={"mt-2"}>
                                        <News onHome={true}/>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default HomePage;
